export interface InfluencerStats {
  start_date: string;
  end_date: string;
}

export const SLICE_NAME = 'influencerStats';
